import { render, staticRenderFns } from "./JXXKZ.vue?vue&type=template&id=1af5ee2e&scoped=true&"
import script from "./JXXKZ.vue?vue&type=script&lang=js&"
export * from "./JXXKZ.vue?vue&type=script&lang=js&"
import style0 from "./JXXKZ.vue?vue&type=style&index=0&id=1af5ee2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af5ee2e",
  null
  
)

export default component.exports